$(document).ready(function () {
  if ($(".framePlusMockUp").length !== 0) {
    // global
    let fpPrices = [];
    let fpPics = [];
    let curPrice = -1;
    let fpMainImgSrc = "";
    let fpMainImg = new Image();
    fpMainImg.crossOrigin = "Anonymous";
    let defaultTab = "Canvas";

    let curType = "horizontal";
    let cropedList = [];
    let cropId = 0;
    let curCrop = -1;
    var cropingId = -1;

    const ZoomMax = 1;
    let ZoomMin = undefined;
    let CanvasWidth = $("#editImage").width();
    let CurAng = 0;
    let CurRaito = 1.5;
    let CurFrame = "landscape";
    let MarginCanvas = [];
    let MarginCanvasCtx = [];
    let CanvasMarginWidth = 14;
    let ZoomCount = 1;
    let FrameLocatin = new Object();
    let templatePath =
      "https://canadaphotolab.com/wp-content/themes/printspace/template-parts/CanvasPrint/templates2/";
    // templatePath = "http://localhost/canvasprint/templates2/"
    let templateVersion = 18;

    FrameLocatin["square"] =
      "https://vancouverphotolab.com/product/framemyphotosquare/";
    FrameLocatin["portrait"] =
      "https://vancouverphotolab.com/product/framemyphotovertical/";
    FrameLocatin["landscape"] =
      "https://vancouverphotolab.com/product/framemyphotohorizontal/";
    FrameLocatin["panorama"] =
      "https://vancouverphotolab.com/product/framemyphotopanaroma/";

    //start

    fpGetData();
    fpSetSizeList();

    $("canvas").attr("width", CanvasWidth);
    $("canvas").attr("height", CanvasWidth / CurRaito);
    fpFabricCanvas = new fabric.Canvas("canvas");
    fpFabricCanvas.set({
      uniScaleTransform: false,
      enableRetinaScaling: true,
      uniScaleKey: "none",
      selection: false,
      containerClass: "fpFabricCanvasArea",
      controlsAboveOverlay: true,
      backgroundColor: "#ccc",
    });
    DefineCanvasMargin();
    fpCheckQueryInput();

    CanvasWidth = $("#editImage").width();
    ChangeCanvasRaito(CurRaito, false);

    //functions

    function fpDotFinder(imgsrc, padding = 0, callBack = function (dots) {}) {
      let img = new Image();
      img.src = imgsrc;
      img.onload = function () {
        let trackCanvas = document.createElement("canvas");
        let trackContext = trackCanvas.getContext("2d");
        trackCanvas.width = img.width;
        trackCanvas.height = img.height;
        trackContext.drawImage(img, 0, 0);
        let myData = trackContext.getImageData(0, 0, img.width, img.height);
        myData = myData.data;
        var dots = {
          leftTop: [],
          leftBottom: [],
          rightTop: [],
          rightBottom: [],
        };

        var list = [];
        for (let i = 0; i < myData.length; i = i + 4) {
          if (myData[i + 3] === 0) {
            list.push([getPX(i), getPY(i)]);
          }
          if (i === myData.length - 4) {
            findPoints();
          }
        }

        function findPoints() {
          dots.leftTop = nearestPoint([0, 0], list);
          dots.leftBottom = nearestPoint([0, img.height], list);
          dots.rightTop = nearestPoint([img.width, 0], list);
          dots.rightBottom = nearestPoint([img.width, img.height], list);

          points = [
            dots.leftTop[0] - padding,
            dots.leftTop[1] - padding,
            dots.rightTop[0] + padding,
            dots.rightTop[1] - padding,
            dots.leftBottom[0] - padding,
            dots.leftBottom[1] + padding,
            dots.rightBottom[0] + padding,
            dots.rightBottom[1] + padding,
          ];

          callBack(points);
        }

        function nearestPoint(point, data) {
          var min;
          var minId;
          for (let i = 0; i < data.length; i++) {
            if (i === 0) {
              min = getDist(point, data[i]);
              minId = i;
            } else {
              var dist = getDist(point, data[i]);
              if (dist < min) {
                min = dist;
                minId = i;
              }
            }

            if (i === data.length - 1) {
              return list[minId];
            }
          }

          function getDist(A, B) {
            return Math.sqrt(
              Math.pow(B[0] - A[0], 2) + Math.pow(B[1] - A[1], 2)
            );
          }
        }

        function getPX(id) {
          return (id / 4) % img.width;
        }
        function getPY(id) {
          return Math.ceil(id / 4 / img.width);
        }
      };
    }

    function fpCheckQueryInput() {
      const url = new URL(window.location.href);
      let canvasMargin = url.searchParams.get("canvasMargin");
      let tabSelect = url.searchParams.get("tabSelect");
      let imgSrc = url.searchParams.get("imgSrc");

      if (canvasMargin != null) {
        if (canvasMargin == 0) {
          $("#CanvasBottom").hide();
          $("#CanvasLeft").hide();
          $("#CanvasRight").hide();
          $("#CanvasTop").hide();
          $("#cropArea").attr("style", "padding: 0px !important");
        }
      }

      if (imgSrc != null) {
        UploadImage("", imgSrc);
      }

      // ---- Inject: preselect size & promo price from URL (Canvas deal) ----
      try {
        const url = new URL(window.location.href);
        var dealSize = url.searchParams.get("size");
        var dealPrice = url.searchParams.get("price");
        if (dealSize) {
          setTimeout(function () {
            // Find matching row in fpPrices (built from DOM)
            var target = null;
            for (var i = 0; i < fpPrices.length; i++) {
              if (fpPrices[i].size === dealSize) { target = fpPrices[i]; break; }
            }
            if (target) {
              // Activate proper orientation tab
              if (target.type === "square") {
                $("#squareRaito").click();
              } else if (target.type === "vertical") {
                $("#portraitRaito").click();
              } else if (target.type === "horizontal") {
                $("#landscapeRaito").click();
              } else if (target.type === "panaroma") {
                $("#panoramaRaito").click();
              }
              // Override price if provided
              if (dealPrice) {
                target.canvas = parseFloat(dealPrice);
                // Update price text inside the size chart DOM (editImageChartPrice div)
                $("#" + target.id).find(".editImageChartPrice")
                  .text("$" + parseFloat(dealPrice).toFixed(2));
              }
              // Select the size row
              $(".editImageChart").find("#" + target.id).click();
              // Refresh prices
              if (typeof fpUpdatePrices === "function") {
                fpUpdatePrices();
              }
            }
          }, 400);
        }
      } catch (e) { console.log("deal preselect err", e); }
      // ---- End Inject ----

    }

    function fpUpdateCrop() {
      $("#loadingCover").show();

      var thumbPic = fpFabricCanvas.toDataURL({ format: "jpeg" });

      var img = document.getElementById("sourceImage");
      var imageWidth = img.naturalWidth;
      var imageHeight = img.naturalHeight;
      var imageRatio = imageWidth / imageHeight;
      var canvasRatio = fpFabricCanvas.width / fpFabricCanvas.height;
      var zoomVal = 1;
      if (imageRatio > canvasRatio)
        zoomVal = imageHeight / fpFabricCanvas.height;
      else zoomVal = imageWidth / fpFabricCanvas.width;
      zoomVal = zoomVal / ZoomCount;

      var mainPic = fpFabricCanvas.toDataURL({
        format: "jpeg",
        multiplier: zoomVal,
      });

      var selOpt = "";
      $("body")
        .find("[data-parent='canvasOptional']")
        .toArray()
        .forEach(function (item) {
          var active = $(item).find(".framePlusMockUpTypeMainOptActive");
          if (active.length > 0) {
            selOpt = active[0];
          }
        });
      var edge = $(selOpt).attr("data-edge");

      cropedList[curCrop] = {
        id: curCrop,
        sourcePic: cropedList[curCrop].sourcePic,
        thumbPic: thumbPic,
        mainPic: mainPic,
        type: curType,
        priceId: curPrice,
        qtn: cropedList[curCrop].qtn,
        name: fpGetName(),
        specName: "",
        edge: edge,
        thick: $("#canvasThickness")
          .find(".framePlusMockUpTypeMainOptActive")
          .attr("data-special"),
      };

      fpUpdatePrices();
      fpUpdateCropList();

      fpMainImg.src = cropedList[curCrop].thumbPic;

      $("#loadingCover").hide();
    }

    function fpThickChange() {
      cropedList[curCrop].thick = $("#canvasThickness")
        .find(".framePlusMockUpTypeMainOptActive")
        .attr("data-special");
    }

    function fpChangeSelSize(elm) {
      curPrice = $(elm).attr("id");
      CurRaito = fpPrices[curPrice].ratio;
      $(".editImageChart")
        .find(".editImageActiveRow")
        .removeClass("editImageActiveRow");
      $(elm).addClass("editImageActiveRow");
      ChangeCanvasRaito(CurRaito);

      fpUpdateCrop();
    }
    function fpChangeOri(elm) {
      if ($(elm).hasClass("active")) return;
      $("#actions").find(".active").removeClass("active");
      $(elm).addClass("active");
      ChangeCanvasRaito(CurRaito);

      fpUpdateCrop();
    }
    function fpUpdateCropList() {
      if (cropedList.length > 0) {
        // $(".framePlusMockUpLeft").addClass("show");
        $(".editImageLeft").addClass("show");
      }

      $(".framePlusMockUpListTable").html("");
      for (let i = 0; i < cropedList.length; i++) {
        if (cropedList[i] === "") continue;
        var crop = cropedList[i];
        if (crop.mainPic !== null) {
          var size = fpPrices[parseInt(crop.priceId)].size;

          $(".framePlusMockUpListTable").append(
            '<div id="crop' +
              crop.id +
              '" class="framePlusMockUpListTableRow">' +
              '<div class="thumb">' +
              '<img src="' +
              crop.thumbPic +
              '">' +
              "</div>" +
              '<div class="info">' +
              "<div>" +
              // '<div>ُSize : </div>'+
              '<div class="framePlusMockUpListSize">' +
              fpGetWidth(size) +
              "×" +
              fpGetHeight(size) +
              "</div>" +
              "</div>" +
              "<div>" +
              // '<div>Price : </div>'+
              '<div class="framePlusMockUpListSize">$' +
              fpGetCropPrice(crop) +
              "</div>" +
              "</div>" +
              "<div>" +
              // '<div>Quntity : </div>'+
              '<div class="framePlusMockUpListQtn">' +
              '<div class="framePlusMockUpListQtnMines">-</div>' +
              '<div class="framePlusMockUpListQtnValue">' +
              '<div id="framePlusMockUpListQtnValue">' +
              crop.qtn +
              "</div> x" +
              "</div>" +
              '<div class="framePlusMockUpListQtnPlus">+</div>' +
              "</div>" +
              "</div>" +
              "</div>" +
              '<div class="framePlusMockUpListDelete">X</div>' +
              "</div>"
          );
        } else {
          $(".framePlusMockUpListTable").append(
            '<div id="crop' +
              crop.id +
              '" class="framePlusMockUpListTableRow">' +
              '<div class="thumb">' +
              '<img src="' +
              crop.thumbPic +
              '">' +
              "</div>" +
              '<div class="info">' +
              "<div>" +
              '<div class="fpCropImage" id="fpCropImage">Use This Image</div>' +
              "</div>" +
              "</div>" +
              '<div class="framePlusMockUpListDelete">X</div>' +
              "</div>"
          );
        }
      }
      $(".framePlusMockUpListTable")
        .find(".framePlusMockUpListTableRowActive")
        .removeClass("framePlusMockUpListTableRowActive");
      $("#crop" + curCrop).addClass("framePlusMockUpListTableRowActive");

      var hasUsed = false;
      cropedList.forEach(function (item) {
        if (item.mainPic != null) {
          hasUsed = true;
        }
      });
      if (!hasUsed) {
        $(".framePlusMockUpListTable")
          .children()
          .first()
          .find(".thumb")
          .click();
      }
    }
    function fpChangeCropPrice(id = curCrop) {
      let crop = cropedList[id];
      $("#crop" + id)
        .find(".framePlusMockUpListPrice")
        .html("$" + fpGetCropPrice(crop));
    }
    function fpGetCropPrice(crop) {
      var priceList = [];
      if (priceId != null) {
        priceList = fpPrices[parseInt(crop.priceId)];
      } else {
        priceList =
          fpPrices[$(".editImageChart").find(".editImageActiveRow").attr("id")];
      }

      let price = "NaN";

      if (crop.name === "photoPaper") price = priceList.photoPrint;
      else if (
        crop.name === "photoPaperMetalBlack" ||
        crop.name === "photoPaperMetalWhite" ||
        crop.name === "photoPaperMetalSilver"
      )
        price =
          parseFloat(priceList.photoPrintMetalFrame) +
          parseFloat(priceList.photoPrint);
      else if (
        crop.name === "photoPaperWoodBlack" ||
        crop.name === "photoPaperWoodWhite"
      )
        price =
          parseFloat(priceList.photoPrintWoodFrame) +
          parseFloat(priceList.photoPrint);
      else if (crop.name === "canvas") price = priceList.canvas;
      else if (
        crop.name === "canvasMetalBlack" ||
        crop.name === "canvasMetalWhite" ||
        crop.name === "canvasMetalSilver"
      )
        price =
          parseFloat(priceList.canvasMetalFrame) + parseFloat(priceList.canvas);
      else if (
        crop.name === "canvasWoodBlack" ||
        crop.name === "canvasWoodWhite"
      )
        price =
          parseFloat(priceList.canvasWoodFrame) + parseFloat(priceList.canvas);
      else if (crop.name === "metal") price = priceList.metal;
      else if (crop.name === "wood") price = priceList.wood;

      return (price * parseInt(crop.qtn)).toFixed(2);
    }
    function fpOpenPopUp() {
      $("body").css("overflow", "hidden");
      $(".framePlusCrop").addClass("framePlusCropPopUp");
      $(".framePlusCrop").css("display", "flex");
      $("#uploadCover").hide();
      $("#editImage").hide();
      $("#uploadImage").show();
      //$(".framePlusMockUpType").find(".framePlusMockUpTypeMainOptActive").removeClass("framePlusMockUpTypeMainOptActive");
    }
    function closePopUp() {
      $("body").css("overflow", "auto");
      $(".framePlusCrop").hide();
    }
    function fpChangeCrop(elm) {
      $("#framePlusMockUpRightCover").hide();
      $("#framePlusBannerCover").hide();

      $(".framePlusMockUp").show();

      if ($(elm).parent().hasClass("framePlusMockUpListTableRowActive")) return;

      var id = $(elm).parent().attr("id");
      id = parseInt(id.replace("crop", ""));
      $("#sourceImage").attr("src", cropedList[id].sourcePic);
      cropingId = id;
      curCrop = id;
      GoToEditMenu();
    }
    function fpRemoveCrop(elm) {
      if (!confirm("Are you sure you want to delete?")) return;

      let id = $(elm).parent().attr("id");
      id = parseInt(id.replace("crop", ""));
      cropedList[id] = "";

      let newId = -1;

      for (let i = 0; i < cropedList.length; i++) {
        if (cropedList[i] !== "" && cropedList[i].mainPic !== null) {
          newId = i;
          break;
        }
      }

      if (newId !== -1) {
        curCrop = newId;
        cropingId = newId;
        curPrice = cropedList[curCrop].priceId;

        fpChangeCrop(
          $(".framePlusMockUpListTable")
            .find("#crop" + curCrop)
            .find(".thumb")[0]
        );
      } else {
        for (let i = 0; i < cropedList.length; i++) {
          if (cropedList[i] !== "") {
            newId = i;
            break;
          }
        }
        if (newId == -1) {
          $("#loadingCover").show();
          location.reload();
        } else {
          fpUpdateCropList();
          $("#framePlusMockUpNoPic").css("display", "flex");
          $("#framePlusMockUpPics").css("display", "none");
        }
      }
    }
    function fpChangeQtn(elm, act) {
      let id = $(elm).parents(".framePlusMockUpListTableRow").attr("id");
      id = parseInt(id.replace("crop", ""));

      let val = $(elm).parent().find("#framePlusMockUpListQtnValue");

      if (act) {
        cropedList[id].qtn += 1;
      } else if (cropedList[id].qtn > 1) cropedList[id].qtn -= 1;

      $(val).html(cropedList[id].qtn);
      fpChangeCropPrice(id);
      fpUpdatePrices();
    }

    //mockup

    //action
    $(".framePlusMockUpPicList").on("click", ">div", function () {
      if ($(this).hasClass("framePlusMockUpPicListActive")) return;
      $(".framePlusMockUpPicList")
        .find(".framePlusMockUpPicListActive")
        .removeClass("framePlusMockUpPicListActive");
      $(this).addClass("framePlusMockUpPicListActive");
      changeMainImage();
    });

    //var
    let fpIsActionOnProcces = false;
    let fpIsActionWaiting = false;
    let fpWaiterTimmer;

    //fucntions

    function changeMainImage() {
      let activeSrc = $(".framePlusMockUpPicList")
        .find(".framePlusMockUpPicListActive")
        .find("img")
        .attr("src");

      $("#framePlusMockUpPicShow").attr("src", activeSrc);

      $("#framePlusMockUpPicShow").parent().trigger("zoom.destroy");

      divWidth = $("#framePlusMockUpPicShow").parent().width();
      picWidth = $("#framePlusMockUpPicShow").get(0).naturalWidth;

      let magnify =
        Math.round((divWidth / picWidth + Number.EPSILON) * 10) / 10;

      $("#framePlusMockUpPicShow")
        .parent()
        .zoom({ url: activeSrc, magnify: magnify * 1.2 });
    }

    //

    function fpGetName() {
      let type = "";

      let activeType = $("#framePlusMockUpTypesTabs")
        .find(".framePlusMockUpTypesTabsActive")
        .attr("data-target");
      let sizeList = fpPrices[curPrice];

      if (activeType === "photoPaperTypeOpt") {
        type = "photoPaper";
        let specName = $("#photoPaperType")
          .find(".framePlusMockUpTypeMainOptActive")
          .attr("data-special");
        if (specName !== undefined) cropedList[curCrop].specName = specName;
        else cropedList[curCrop].specName = "";
        let optional = $("#photoPaperOptional").find(
          ".framePlusMockUpTypeMainOptActive"
        );
        if (optional.length !== 0) {
          type = $(optional).attr("data-fptype");
        }
      } else if (activeType === "canvasTypeOpt") {
        type = "canvas";
        //cropedList[curCrop].specName = "";

        var optional = "";
        $("body")
          .find("[data-parent='canvasOptional']")
          .toArray()
          .forEach(function (item) {
            var active = $(item).find(".framePlusMockUpTypeMainOptActive");
            if (active.length > 0) {
              optional = active[0];
            }
          });

        if (optional.length !== 0) {
          type = $(optional).attr("data-fptype");
        }
      } else if (activeType === "metalTypeOpt") {
        type = "metal";
        cropedList[curCrop].specName = "";
      } else if (activeType === "woodTypeOpt") {
        type = "wood";
        cropedList[curCrop].specName = "";
      }
      return type;
    }
    function fpGetData() {
      let sizeList = $("#framePlusMockUpDataSizeList").children();
      let priceId = 0;
      for (let i = 0; i < sizeList.length; i++) {
        let sizePrices = $(sizeList[i]).children();
        if ($(sizePrices[0]).html() === "") continue;

        let ratio = fpGetRatio($(sizePrices[0]).html());
        let type = "";

        if ($(sizeList[i]).attr("data-type") === "panaroma") {
          type = "panaroma";
        } else if (ratio === 1) {
          type = "square";
        } else if (ratio > 1 && ratio < 2.1) {
          type = "horizontal";
        }
        // else if(ratio >= 2)
        // {
        //     type = "panaroma";
        // }
        else {
          type = "vertical";
        }

        let tmpObj = new Object();
        tmpObj["id"] = priceId++;
        tmpObj["type"] = type;
        tmpObj["size"] = $(sizePrices[0]).html();
        tmpObj["ratio"] = ratio;
        tmpObj["photoPrint"] = $(sizePrices[1]).html();
        tmpObj["photoPrintMetalFrame"] = $(sizePrices[2]).html();
        tmpObj["photoPrintWoodFrame"] = $(sizePrices[3]).html();
        tmpObj["canvas"] = $(sizePrices[4]).html();
        tmpObj["canvasMetalFrame"] = $(sizePrices[5]).html();
        tmpObj["canvasWoodFrame"] = $(sizePrices[6]).html();
        tmpObj["metal"] = $(sizePrices[7]).html();
        tmpObj["wood"] = $(sizePrices[8]).html();

        fpPrices.push(tmpObj);
      }

      let picId = 0;
      let picList = $("#framePlusMockUpDataPicList").children();
      for (let i = 0; i < picList.length; i++) {
        let nameList = $(picList[i]).children();
        for (let l = 0; l < nameList.length; l++) {
          let typeList = $(nameList[l]).children();
          for (let j = 0; j < typeList.length; j++) {
            if (
              $(typeList[j]).html() === "" ||
              $(picList[i]).attr("data-name") === ""
            )
              continue;
            fpPics.push({
              id: picId++,
              type: $(nameList[l]).attr("data-type"),
              name: $(picList[i]).attr("data-name"),
              src: $(typeList[j]).html(),
              points: $(typeList[j])
                .attr("data-points")
                .split(",")
                .map((x) => +x),
            });
          }
        }
      }
    }
    function fpSetSizeList() {
      //for mockup

      for (let i = 0; i < fpPrices.length; i++) {
        let size = fpPrices[i].size;
        $("#framePlusMockUpSizes").append(
          '<div class="framePlusMockUpSizeBtn"' +
            'data-value="' +
            size +
            '">' +
            fpGetWidth(size) +
            "×" +
            fpGetHeight(size) +
            '"' +
            "</div>"
        );
      }
      $("#framePlusMockUpSizes")
        .children()
        .first()
        .addClass("framePlusMockUpSizeBtnActive");
      curPrice = 0;

      //for crop
      $(".editImageChart").html("");
      $("#editImageRightTitle").html(CurFrame.toUpperCase());
      let sizeList = fpPrices.filter((item) => item.type === curType);
      for (let i = 0; i < sizeList.length; i++) {
        if (sizeList[i].canvas === "") continue;
        let active = "";
        if (i === 0) {
          active = "editImageActiveRow";
          curPrice = sizeList[i].id;
        }
        let size = sizeList[i].size;
        $(".editImageChart").append(
          "<div class='editImageChartRow clearBoth " +
            active +
            "' id='" +
            sizeList[i].id +
            "' >" +
            "<div class='editImageChartDimension'> " +
            fpGetWidth(size) +
            "×" +
            fpGetHeight(size) +
            '"</div>' +
            "<div class='editImageChartPrice'>$ " +
            sizeList[i].canvas +
            "</div>" +
            "<div class='editImageChartSelect'>Selected</div>" +
            "</div>"
        );
      }
    }
    function fpGetWidth(str) {
      return str.split("-")[0];
    }
    function fpGetHeight(str) {
      return str.split("-")[1];
    }
    function fpGetRatio(str) {
      return str.split("-")[0] / str.split("-")[1];
    }
    function ChangeMenu(element) {
      let target = $(element).attr("data-target");
      $(element)
        .parent()
        .find(".framePlusMockUpTypesTabsActive")
        .removeClass("framePlusMockUpTypesTabsActive");
      $(element).addClass("framePlusMockUpTypesTabsActive");
      $(".framePlusMockUpTypes")
        .find(".framePlusMockUpTypeActive")
        .removeClass("framePlusMockUpTypeActive");
      $(".framePlusMockUpTypes")
        .find("#" + target)
        .addClass("framePlusMockUpTypeActive");
      fpUpdatePrices();
    }
    function fpUpdatePrices() {
      $("#framePlusMockUpTypesTabs").find(">div").show();

      cropedList[curCrop].name = fpGetName();

      fpChangeCropPrice();

      let sizeList = fpPrices[curPrice];

      if (sizeList.photoPrint === "") {
        $("#photoPaperTypeOpt").hide();
        $("#framePlusMockUpTypesTabs")
          .find("[data-target=photoPaperTypeOpt]")
          .hide();
      } else if (
        sizeList.photoPrintMetalFrame === "" ||
        sizeList.photoPrintWoodFrame === ""
      ) {
        $("#photoPaperTypeOpt")
          .find(".framePlusMockUpTypeOptionalHeader")
          .hide();
        $("#photoPaperTypeOpt").find(".framePlusMockUpTypeOptional").hide();
      } else {
        $("#photoPaperTypeOpt")
          .find(".framePlusMockUpTypeOptionalHeader")
          .show();
        $("#photoPaperTypeOpt").find(".framePlusMockUpTypeOptional").show();
      }
      $("#photoPrintPrice").html("$" + sizeList.photoPrint);
      $("#photoPrintMetalFramePrice").html(
        "($" + sizeList.photoPrintMetalFrame + ")"
      );
      $("#photoPrintWoodFramePrice").html(
        "($" + sizeList.photoPrintWoodFrame + ")"
      );

      if (sizeList.canvas === "") {
        $("#canvasTypeOpt").hide();
        $("#framePlusMockUpTypesTabs")
          .find("[data-target=canvasTypeOpt]")
          .hide();
      } else if (
        sizeList.canvasMetalFrame === "" ||
        sizeList.canvasWoodFrame === ""
      ) {
        $("#canvasTypeOpt").find(".framePlusMockUpTypeOptionalHeader").hide();
        $("#canvasTypeOpt").find(".framePlusMockUpTypeOptional").hide();
      } else {
        $("#canvasTypeOpt").find(".framePlusMockUpTypeOptionalHeader").show();
        $("#canvasTypeOpt").find(".framePlusMockUpTypeOptional").show();
      }

      $("#canvasPrice").html("$" + sizeList.canvas);
      $("#canvasMetalFramePrice").html("($" + sizeList.canvasMetalFrame + ")");
      $("#canvasWoodFramePrice").html("($" + sizeList.canvasWoodFrame + ")");

      if (sizeList.metal === "") {
        $("#metalTypeOpt").hide();
        $("#framePlusMockUpTypesTabs")
          .find("[data-target=metalTypeOpt]")
          .hide();
      } else $("#metalPrice").html("$" + sizeList.metal);

      if (sizeList.wood === "") {
        $("#woodTypeOpt").hide();
        $("#framePlusMockUpTypesTabs").find("[data-target=woodTypeOpt]").hide();
      } else $("#woodPrice").html("$" + sizeList.wood);

      $("#totlaPrice").html("$" + fpGetTotalPrice());
    }
    function fpAddToCart() {
      var UsedCropList = [];

      cropedList.forEach(function (item) {
        if (item.mainPic !== null && item !== "") {
          UsedCropList.push(item);
        }
      });

      if (UsedCropList.length == 0) return;

      var uploadList = [];

      UsedCropList.forEach(function (item) {
        uploadList.push(item.mainPic);
      });

      canadaUploader(uploadList, "CanvasPrint", "jpeg", function (response) {
        var urlList = response;
        var frameList = "";
        var sizeList = "";
        var qtnList = "";
        var edgeList = "";
        var thickList = "";
        var totalPrice = fpGetTotalPrice();

        UsedCropList.forEach(function (item) {
          if (item.specName === "") frameList += item.name + "\n";
          else frameList += item.name + " - " + item.specName + "|";

          sizeList += fpPrices[item.priceId].size + "\n";

          qtnList += item.qtn + "\n";

          edgeList += item.edge + "\n";

          thickList += item.thick + "\n";
        });

        var formData = new FormData();

        formData.append("order_url", urlList);
        formData.append("order_frame", frameList);
        formData.append("order_size", sizeList);
        formData.append("order_quntity", qtnList);
        formData.append("order_edge", edgeList);
        formData.append("order_thick", thickList);
        formData.append("price", totalPrice);
        formData.append("title","Canvas Prints");
        formData.append("product_type","CanvasPrints");
        formData.append("image_url",urlList.split('\n')[0].trim());
        
        $.ajax({
          url: "https://canadaphotolab.com/wp-content/themes/printspace/shopify/create_draft_order.php",
          method: "POST",
          data: formData,
          contentType: false,
          processData: false,
          dataType: "json",
          success: function (response) {
            if (response.success) {
              window.location.href = response.url;
            } else {
              alert("Error: " + (response.message || "Something went wrong"));
              console.log(response);
            }
          },
          error: function (xhr, status, error) {
            alert("AJAX error: " + xhr.responseText + " " + status + " " + error);
            console.log(xhr.responseText);
          },
        });
      });
    }
    function fpGetTotalPrice() {
      let totlaPrice = 0;
      for (let i = 0; i < cropedList.length; i++) {
        if (cropedList[i] === "" || cropedList[i].mainPic == null) continue;
        totlaPrice += parseFloat(fpGetCropPrice(cropedList[i]));
      }
      return totlaPrice.toFixed(2);
    }
    function fpGhangeSize(element) {
      $(element)
        .parent()
        .find(".framePlusMockUpSizeBtnActive")
        .removeClass("framePlusMockUpSizeBtnActive");
      $(element).addClass("framePlusMockUpSizeBtnActive");
      curPrice = $(element).index();
      fpUpdatePrices();
    }
    function fpGhangeOptSle(element) {
      if (
        $(element).hasClass("framePlusMockUpTypeMainOptActive") &&
        !$(element).hasClass("framePlusMockUpTypeMainOptForce")
      ) {
        $(element).removeClass("framePlusMockUpTypeMainOptActive");
        fpUpdatePrices();

        fpUpdateCrop();
        CanvasMargin();
      } else if (
        $(element).hasClass("framePlusMockUpTypeMainOptActive") &&
        ($(element).attr("data-edge") == "metal-black" ||
          $(element).attr("data-edge") == "metal-silver" ||
          $(element).attr("data-edge") == "wood-black" ||
          $(element).attr("data-edge") == "wood-white")
      ) {
        $("#canvasTypeOpt").find("[data-edge='mirror']")[0].click();
      } else {
        var selGrp = $(element).attr("data-group");
        if (selGrp === undefined) {
          $(element)
            .parent()
            .find(".framePlusMockUpTypeMainOptActive")
            .removeClass("framePlusMockUpTypeMainOptActive");
          $(element).addClass("framePlusMockUpTypeMainOptActive");
        } else {
          $("body")
            .find("[data-parent='" + selGrp + "']")
            .toArray()
            .forEach(function (item) {
              $(item)
                .find(".framePlusMockUpTypeMainOptActive")
                .removeClass("framePlusMockUpTypeMainOptActive");
            });
          $(element).addClass("framePlusMockUpTypeMainOptActive");
          fpUpdatePrices();
        }

        fpUpdateCrop();
        CanvasMargin();
      }

      if ($(element).parent().attr("id") == "canvasThickness") {
        fpThickChange();
      }
    }
    function fpGhangeQtn(className) {
      if (className === "framePlusMockUpFinishBtnQtnPlus") {
        let qtn = parseInt($(".framePlusMockUpFinishBtnQtnValue").html()) + 1;
        $(".framePlusMockUpFinishBtnQtnValue").html(qtn);
      } else if (className === "framePlusMockUpFinishBtnQtnMines") {
        let qtn = parseInt($(".framePlusMockUpFinishBtnQtnValue").html()) - 1;
        if (qtn > 0) $(".framePlusMockUpFinishBtnQtnValue").html(qtn);
      }
      fpUpdatePrices();
    }

    //
    function DefineCanvasMargin() {
      MarginCanvas[0] = document.getElementById("CanvasTop");
      MarginCanvas[1] = document.getElementById("CanvasRight");
      MarginCanvas[2] = document.getElementById("CanvasBottom");
      MarginCanvas[3] = document.getElementById("CanvasLeft");

      MarginCanvas[0].height = CanvasMarginWidth;
      MarginCanvas[2].height = CanvasMarginWidth;
      MarginCanvas[1].width = CanvasMarginWidth;
      MarginCanvas[3].width = CanvasMarginWidth;

      MarginCanvasCtx[0] = MarginCanvas[0].getContext("2d");
      MarginCanvasCtx[1] = MarginCanvas[1].getContext("2d");
      MarginCanvasCtx[2] = MarginCanvas[2].getContext("2d");
      MarginCanvasCtx[3] = MarginCanvas[3].getContext("2d");
    }
    function CanvasMargin() {
      if (true /*plSelCrop.type === "Canvas"*/) {
        // $("#cropArea").addClass("canvasConHasMargin");
        // $("#cropArea").children(".CanvasMargin").show();

        MarginCanvas[0].width = fpFabricCanvas.width;
        MarginCanvas[2].width = fpFabricCanvas.width;
        MarginCanvas[1].height = fpFabricCanvas.height;
        MarginCanvas[3].height = fpFabricCanvas.height;

        var selOpt = "";
        $("body")
          .find("[data-parent='canvasOptional']")
          .toArray()
          .forEach(function (item) {
            var active = $(item).find(".framePlusMockUpTypeMainOptActive");
            if (active.length > 0) {
              selOpt = active[0];
            }
          });
        var edge = $(selOpt).attr("data-edge");

        if (edge == "mirror") {
          edgeCanvasShow();

          let cropImage = new Image();
          cropImage.src = fpFabricCanvas.toDataURL();
          cropImage.onload = function () {
            let width = cropImage.width;
            let height = cropImage.height;

            MarginCanvasCtx[0].translate(0, height);
            MarginCanvasCtx[0].scale(1, -1);
            MarginCanvasCtx[0].drawImage(
              cropImage,
              0,
              height - CanvasMarginWidth
            );

            MarginCanvasCtx[1].translate(width, 0);
            MarginCanvasCtx[1].scale(-1, 1);
            MarginCanvasCtx[1].drawImage(cropImage, 0, 0);

            MarginCanvasCtx[2].translate(0, height);
            MarginCanvasCtx[2].scale(1, -1);
            MarginCanvasCtx[2].drawImage(cropImage, 0, 0);

            MarginCanvasCtx[3].translate(width, 0);
            MarginCanvasCtx[3].scale(-1, 1);
            MarginCanvasCtx[3].drawImage(
              cropImage,
              width - CanvasMarginWidth,
              0
            );
          };
        } else if (edge == "black") {
          edgeCanvasShow();

          var width = fpFabricCanvas.width;
          var height = fpFabricCanvas.height;

          MarginCanvasCtx[0].fillStyle = "black";
          MarginCanvasCtx[0].fillRect(0, 0, width, height);

          MarginCanvasCtx[1].fillStyle = "black";
          MarginCanvasCtx[1].fillRect(0, 0, width, height);

          MarginCanvasCtx[2].fillStyle = "black";
          MarginCanvasCtx[2].fillRect(0, 0, width, height);

          MarginCanvasCtx[3].fillStyle = "black";
          MarginCanvasCtx[3].fillRect(0, 0, width, height);

          $("#CanvasTop").css("opacity", "1");
          $("#CanvasRight").css("opacity", "1");
          $("#CanvasBottom").css("opacity", "1");
          $("#CanvasLeft").css("opacity", "1");
        } else if (edge == "white") {
          edgeCanvasShow();

          var width = fpFabricCanvas.width;
          var height = fpFabricCanvas.height;

          MarginCanvasCtx[0].fillStyle = "#ccc";
          MarginCanvasCtx[0].fillRect(0, 0, width, height);

          MarginCanvasCtx[1].fillStyle = "#ccc";
          MarginCanvasCtx[1].fillRect(0, 0, width, height);

          MarginCanvasCtx[2].fillStyle = "#ccc";
          MarginCanvasCtx[2].fillRect(0, 0, width, height);

          MarginCanvasCtx[3].fillStyle = "#ccc";
          MarginCanvasCtx[3].fillRect(0, 0, width, height);
        } else if (edge == "metal-black") {
          edgeCanvasHide();

          $("#cropArea").css(
            "border-image-source",
            "url(https://canadaphotolab.com/wp-content/themes/printspace/template-parts/CanvasPrint/Pics/edge-metal-black.jpg)"
          );
        } else if (edge == "metal-silver") {
          edgeCanvasHide();

          $("#cropArea").css(
            "border-image-source",
            "url(https://canadaphotolab.com/wp-content/themes/printspace/template-parts/CanvasPrint/Pics/edge-metal-silver.jpg)"
          );
        } else if (edge == "wood-black") {
          edgeCanvasHide();

          $("#cropArea").css(
            "border-image-source",
            "url(https://canadaphotolab.com/wp-content/themes/printspace/template-parts/CanvasPrint/Pics/edge-wood-black.jpg?ver=2)"
          );
        } else if (edge == "wood-white") {
          edgeCanvasHide();

          $("#cropArea").css(
            "border-image-source",
            "url(https://canadaphotolab.com/wp-content/themes/printspace/template-parts/CanvasPrint/Pics/edge-wood-white.jpg?ver=2)"
          );
        }

        // if(cropedList.length > 0)
        // {
        //     fpUpdateCrop();
        // }
      } else {
        // $(".phLabCanvasCon").removeClass("phLabCanvasConHasMargin");
        // $(".phLabCanvasCon").children(".phLabCanvasMargin").hide();
      }

      function edgeCanvasHide() {
        $("#cropArea").css("padding", "0");
        $("#cropArea").css("border-width", CanvasMarginWidth + "px");
        $("#CanvasTop").hide();
        $("#CanvasRight").hide();
        $("#CanvasBottom").hide();
        $("#CanvasLeft").hide();
      }
      function edgeCanvasShow() {
        $("#cropArea").css("padding", CanvasMarginWidth + "px");
        $("#cropArea").css("border-width", "0");
        $("#CanvasTop").css("opacity", "0.5").show();
        $("#CanvasRight").css("opacity", "0.5").show();
        $("#CanvasBottom").css("opacity", "0.5").show();
        $("#CanvasLeft").css("opacity", "0.5").show();
      }
    }
    function GetLeft(obj) {
      if (CurAng == 0 || CurAng == 270) return obj.left;
      else if (CurAng == 90 || CurAng == 180) return obj.left - GetWidth(obj);
    }
    function SetLeft(obj, val) {
      if (CurAng == 0 || CurAng == 270) obj.left = val;
      else if (CurAng == 90 || CurAng == 180) obj.left = val + GetWidth(obj);
      fpFabricCanvas.renderAll();
    }
    function GetTop(obj) {
      if (CurAng == 0 || CurAng == 90) return obj.top;
      else if (CurAng == 180 || CurAng == 270) return obj.top - GetHeight(obj);
    }
    function SetTop(obj, val) {
      if (CurAng == 0 || CurAng == 90) obj.top = val;
      else if (CurAng == 180 || CurAng == 270) obj.top = val + GetHeight(obj);
      fpFabricCanvas.renderAll();
    }
    function GetWidth(obj) {
      if (CurAng == 0 || CurAng == 180) return obj.getScaledWidth();
      else if (CurAng == 90 || CurAng == 270) return obj.getScaledHeight();
    }
    function GetHeight(obj) {
      if (CurAng == 0 || CurAng == 180) return obj.getScaledHeight();
      else if (CurAng == 90 || CurAng == 270) return obj.getScaledWidth();
    }
    function SetWidth(obj, val) {
      var scaleX = 1;
      if (CurAng == 0 || CurAng == 180) scaleX = val / obj.width;
      else if (CurAng == 90 || CurAng == 270) scaleX = val / obj.height;
      obj.scaleX = scaleX;
      obj.scaleY = scaleX;
    }
    function SetHeight(obj, val) {
      var scaleX = 1;
      if (CurAng == 0 || CurAng == 180) scaleX = val / obj.height;
      else if (CurAng == 90 || CurAng == 270) scaleX = val / obj.width;
      obj.scaleX = scaleX;
      obj.scaleY = scaleX;
    }
    function UploadImage(files, imgSrc = "") {
      // if (file.length > 1) {
      //     alert("Just one image file should be select.");
      //     return;
      // }

      if (imgSrc == "") {
        for (i = 0; i < files.length; i++) {
          if (!files[i].type.match("image")) {
            alert(files[i].name + " is not image file");
            $("#loadingCover").hide();
            return;
          }

          let picReader = new FileReader();
          picReader.readAsDataURL(files[i]);
          picReader.onerorr = function () {
            $("#loadingCover").hide();
            alert("Can't read this file : " + files[i].name);
          };
          picReader.onload = function () {
            addPic(picReader.result);
          };
        }
      } else {
        $("#loadingCover").show();

        if (imgSrc.includes("|||")) {
          imgSrc = imgSrc.split("|||");
          imgSrc.splice(-1);
          imgSrc.forEach(function (image) {
            imageToBase64(image)
              .then(function (base64Image) {
                addPic(base64Image);
              })
              .catch(function (error) {
                console.error("Error:", error);
              });
          });
        } else {
          imageToBase64(imgSrc)
            .then(function (base64Image) {
              addPic(base64Image);
            })
            .catch(function (error) {
              console.error("Error:", error);
            });
        }
      }

      function addPic(picReaderResult) {
        var thumbImg = new Image();
        thumbImg.src = picReaderResult;
        thumbImg.onload = function () {
          var maxWidht = 200;
          var maxHeigth = 200;
          var maxRatio = maxWidht / maxHeigth;

          var imageWidth = thumbImg.width;
          var imageHeigth = thumbImg.height;
          var imageRatio = imageWidth / imageHeigth;

          var scale;
          if (imageRatio <= maxRatio) scale = maxWidht / imageWidth;
          else scale = maxHeigth / imageHeigth;

          var width = (thumbImg.width *= scale);
          var height = (thumbImg.height *= scale);

          var thumbCanvas = document.createElement("canvas");
          thumbCanvas.width = width;
          thumbCanvas.height = height;

          var thumbCanvasCtx = thumbCanvas.getContext("2d");
          thumbCanvasCtx.drawImage(thumbImg, 0, 0, width, height);
          thumbImg.src = thumbCanvas.toDataURL("image/jpeg");

          thumbImg.onload = function () {
            cropedList.push({
              id: cropId,
              sourcePic: picReaderResult,
              thumbPic: thumbImg.src,
              mainPic: null,
              type: null,
              priceId: null,
              qtn: 1,
              name: null,
              specName: "",
              edge: null,
              thick: 1.15,
            });
            fpUpdateCropList();

            cropId++;

            $("#canvasStart,.sh-tab-wise-img-2-section").hide();
            $(".framePlusMockUp").css("display", "flex");

            $("#loadingCover").hide();
          };
        };
      }

      function imageToBase64(url) {
        return $.ajax({
          url: url,
          method: "GET",
          xhrFields: {
            responseType: "blob", // Ensures the response is a Blob object
          },
        }).then(function (blob) {
          return new Promise(function (resolve, reject) {
            const reader = new FileReader();
            reader.onloadend = function () {
              resolve(reader.result); // Base64 string
            };
            reader.onerror = function () {
              reject("Failed to convert image to Base64");
            };
            reader.readAsDataURL(blob); // Convert blob to base64
          });
        });
      }
    }
    function GoToEditMenu() {
      $(".framePlusCrop").css("display", "flex");
      AddImageToFacic($("#sourceImage").get(0));
    }
    function AddImageToFacic(imgElement) {
      $("#loadingCover").show();

      imgElement.onload = function () {
        if (fpFabricCanvas._objects[0] != undefined)
          fpFabricCanvas.remove(fpFabricCanvas._objects[0]);
        var imgInstance = new fabric.Image(imgElement, {
          left: 0,
          top: 0,
          opacity: 1,
          hasRotatingPoint: false,
          transparentCorners: false,
          hasControls: false,
          centeredRotation: true,
        });
        fpFabricCanvas.add(imgInstance);
        ChangeCanvasRaito(CurRaito);
        fpFabricCanvas.renderAll();

        priceId = cropedList[cropingId].priceId;
        if (priceId !== null) {
          //thick
          $("#canvasThickness")
            .find(".framePlusMockUpTypeMainOptActive")
            .removeClass("framePlusMockUpTypeMainOptActive");
          $("#canvasThickness")
            .find("[data-special='" + cropedList[curCrop].thick + "']")
            .addClass("framePlusMockUpTypeMainOptActive");

          $("body")
            .find("[data-edge='" + cropedList[cropingId].edge + "']")
            .click();

          if (fpPrices[priceId].type === "horizontal") {
            $("#landscapeRaito").click();
          } else if (fpPrices[priceId].type === "vertical") {
            $("#portraitRaito").click();
          } else if (fpPrices[priceId].type === "square") {
            $("#squareRaito").click();
          } else if (fpPrices[priceId].type === "panaroma") {
            $("#panoramaRaito").click();
          }

          $(".editImageChart")
            .find("#" + priceId)
            .click();
        } else {
          //thick
          $("#canvasThickness")
            .find(".framePlusMockUpTypeMainOptActive")
            .removeClass("framePlusMockUpTypeMainOptActive");
          $("#canvasThickness")
            .children()
            .first()
            .addClass("framePlusMockUpTypeMainOptActive");

          var width = fpFabricCanvas._objects[0].width;
          var height = fpFabricCanvas._objects[0].height;
          var raito = width / height;

          $("body").find("[data-edge='mirror']").click();

          if (raito < 1) {
            $("#portraitRaito").click();
            $(".editImageChart").children().first().click();
          } else if (raito == 1) {
            $("#squareRaito").click();
            $(".editImageChart").children().first().click();
          } else if (raito >= 2) {
            $("#panoramaRaito").click();
            $(".editImageChart").children().first().click();
          } else {
            $("#landscapeRaito").click();
            $(".editImageChart").children().first().click();
          }
        }

        setTimeout(function () {
          CanvasMargin();
        }, 100);

        fpUpdateCrop();
        $("#loadingCover").hide();
      };
    }
    function FitImageToCanvas() {
      $("#zoom").val(0);
      if (ZoomMin != undefined) ZoomAction(0);
      let imgInstance = fpFabricCanvas._objects[0];
      let imgRaito = GetWidth(imgInstance) / GetHeight(imgInstance);
      let imgWidth = GetWidth(imgInstance);
      let imgHeight = GetHeight(imgInstance);
      let trgRaito = fpFabricCanvas.getWidth() / fpFabricCanvas.getHeight();
      let trgWidth = fpFabricCanvas.getWidth();
      let trgHeight = fpFabricCanvas.getHeight();
      if (imgRaito <= trgRaito) {
        SetWidth(imgInstance, trgWidth);
        SetTop(
          imgInstance,
          -((imgHeight * (trgWidth / imgWidth) - trgHeight) / 2)
        );
        SetLeft(imgInstance, 0);
      } else {
        SetHeight(imgInstance, trgHeight);
        SetLeft(
          imgInstance,
          -((imgWidth * (trgHeight / imgHeight) - trgWidth) / 2)
        );
        SetTop(imgInstance, 0);
      }
      ZoomMin = imgInstance.scaleX;
    }
    function ChangeCanvasRaito(raito, fit = true) {
      let maxHeight = 300;
      let maxWidth = $(".editImageLeft").width() - 20 - CanvasMarginWidth * 2;
      let canvasHeight = maxWidth / raito;

      if (canvasHeight >= maxHeight)
        fpFabricCanvas.setWidth(maxHeight * raito).setHeight(maxHeight);
      else
        fpFabricCanvas.setWidth(canvasHeight * raito).setHeight(canvasHeight);

      if (fit) {
        FitImageToCanvas();
      }
      fpFabricCanvas.renderAll();
      CanvasMargin();
    }
    function PreventMovingOverflow(options) {
      if (!options.target) return;

      let tgHeight = GetHeight(options.target);
      let tgWidth = GetWidth(options.target);
      let tgTop = GetTop(options.target);
      let tgLeft = GetLeft(options.target);
      let tgBottom = tgHeight + tgTop;
      let tgRight = tgWidth + tgLeft;
      if (tgLeft > 0) {
        SetLeft(options.target, 0);
      }
      if (tgTop > 0) {
        SetTop(options.target, 0);
      }
      if (tgRight < fpFabricCanvas.getWidth()) {
        SetLeft(options.target, fpFabricCanvas.getWidth() - tgWidth);
      }
      if (tgBottom < fpFabricCanvas.getHeight()) {
        SetTop(options.target, fpFabricCanvas.getHeight() - tgHeight);
      }
    }
    function ZoomAction(zoomVal) {
      ZoomCount = (zoomVal / 100) * ZoomMax + 1;
      let imageObj = fpFabricCanvas._objects[0];
      imageObj.scaleX = ZoomMin * ZoomCount;
      imageObj.scaleY = ZoomMin * ZoomCount;
      fpFabricCanvas.renderAll();
      let tgHeight = GetHeight(imageObj);
      let tgWidth = GetWidth(imageObj);
      let tgTop = GetTop(imageObj);
      let tgLeft = GetLeft(imageObj);
      let tgBottom = tgHeight + tgTop;
      let tgRight = tgWidth + tgLeft;
      if (tgLeft > 0) {
        SetLeft(imageObj, 0);
      }
      if (tgTop > 0) {
        SetTop(imageObj, 0);
      }
      if (tgRight < fpFabricCanvas.getWidth()) {
        SetLeft(imageObj, fpFabricCanvas.getWidth() - tgWidth);
      }
      if (tgBottom < fpFabricCanvas.getHeight()) {
        SetTop(imageObj, fpFabricCanvas.getHeight() - tgHeight);
      }
      fpFabricCanvas.renderAll();
    }
    function RotateAction() {
      $("#zoom").val(0);
      ZoomAction(0);
      let imgObj = fpFabricCanvas._objects[0];
      CurAng = (imgObj.angle + 90) % 360;
      imgObj.rotate(CurAng).setCoords();
      if (CurAng == 90 || CurAng == 270)
        SetWidth(imgObj, fpFabricCanvas.getWidth());
      FitImageToCanvas();
      fpFabricCanvas.renderAll();
      CanvasMargin();
    }

    //actions

    $(".framePlusMockUpCanvasThickness").on("change", "input", function () {
      $("#input_11_10").val(
        $(
          "input[name=canvasThickness]:checked",
          "#framePlusMockUpCanvasThickness"
        ).val()
      );
    });

    $(".editImageChart").on("click", ">div", function () {
      fpChangeSelSize(this);
    });

    $("#framePlusMockUpListNew").click(function () {
      fpOpenPopUp();
    });

    $(".framePlusMockUpListTable").on("click", ".thumb", function () {
      fpChangeCrop(this);
    });

    $(".framePlusMockUpListTable").on("click", ".fpCropImage", function () {
      fpChangeCrop($(this).parent().parent());
    });

    $(".framePlusMockUpListTable").on(
      "click",
      ".framePlusMockUpListDelete",
      function () {
        fpRemoveCrop(this);
      }
    );

    $(".framePlusMockUpListTable").on(
      "click",
      ".framePlusMockUpListQtnMines",
      function () {
        fpChangeQtn(this, false);
      }
    );
    $(".framePlusMockUpListTable").on(
      "click",
      ".framePlusMockUpListQtnPlus",
      function () {
        fpChangeQtn(this, true);
      }
    );

    $("#closePopUp").click(function () {
      closePopUp();
    });

    //

    $("#framePlusMockUpTypesTabs").on("click", ">div", function () {
      if ($(this).hasClass("framePlusMockUpTypesTabsActive")) return;
      ChangeMenu($(this));
      
    });

    $("#framePlusMockUpSizes").on("click", ">div", function () {
      if ($(this).hasClass("framePlusMockUpSizeBtnActive")) return;
      fpGhangeSize($(this));
    });

    $(".framePlusMockUpTypeMainOpt").on("click", ">div", function () {
      if ($("#framePlusMockUpNoPic").is(":visible")) {
        alert("Please upload your images first");
        return;
      }

      if (
        $(this).hasClass("framePlusMockUpTypeMainOptStatic") ||
        $(this).hasClass("framePlusMockUpTypeMainOptPrice")
      )
        return;
      fpGhangeOptSle($(this));
      
    });

    $(".framePlusMockUpFinishBtnQtn").on("click", ">div", function () {
      fpGhangeQtn($(this).attr("class"));
    });

    $(".framePlusMockUpFinishBtnAddToCart").click(function () {
      if ($("#framePlusMockUpNoPic").is(":visible")) {
        alert("Please upload your images first");
        return;
      } else {
        fpAddToCart();
      }
    });

    //

    fpFabricCanvas.on("object:moved", function () {
      CanvasMargin();
    });

    $(".frameMyUploadArea").click(function () {
      $("#frameMyAddImageByClick").val("");
      $("#frameMyAddImageByClick").click();
    });

    $("#framePlusMockUpRightCoverBtn,#canvasStartUpload,.sh-tab-item-active .sh-twi-2-tab-item-media-box p").click(function () {
      $("#frameMyAddImageByClick").val("");
      $("#frameMyAddImageByClick").click();
    });

    $("#frameMyAddImageByClick").change(function (e) {
      $("#loadingCover").show();
      UploadImage(e.target.files);
    });

    $(document).on("input", "#zoom", function () {
      ZoomAction($(this).val());
    });
    $(document).on("input", "#zoom", function () {
      setTimeout(function () {
        CanvasMargin();
      }, 200);
    });

    fpFabricCanvas.on("object:moving", function (options) {
      PreventMovingOverflow(options);
    });

    $("#rotatePic").click(function () {
      RotateAction();
    });

    $("#squareRaito").click(function () {
      CurFrame = "square";
      curType = "square";
      fpSetSizeList();
      CurRaito = fpPrices[curPrice].ratio;
      fpChangeOri(this);
    });

    $("#landscapeRaito").click(function () {
      CurFrame = "landscape";
      curType = "horizontal";
      fpSetSizeList();
      CurRaito = fpPrices[curPrice].ratio;
      fpChangeOri(this);
    });

    $("#portraitRaito").click(function () {
      CurFrame = "portrait";
      curType = "vertical";
      fpSetSizeList();
      CurRaito = fpPrices[curPrice].ratio;
      fpChangeOri(this);
    });

    $("#panoramaRaito").click(function () {
      CurFrame = "panorama";
      curType = "panaroma";
      fpSetSizeList();
      CurRaito = fpPrices[curPrice].ratio;
      fpChangeOri(this);
    });

    $(window).resize(function () {
      if ($("#editImage").is(":visible")) {
        CanvasWidth = $("#editImage").width();
        ChangeCanvasRaito(CurRaito);
      }
    });

    $("#navBack,#editImageBackBtn").click(function () {
      $(".framePlusCrop").hide();
    });
    $("#navNext,#editImageNextBtn").click(function () {
      SendPhotoToMockup();
    });

    // drag and drop

    $(".frameMyUploadArea").droppable();
    $(".frameMyUploadArea").on("dragover", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass("frameMyUploadAreaDrag");
    });
    $(".frameMyUploadArea").on("dragenter", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    $(".frameMyUploadArea").on("dragleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass("frameMyUploadAreaDrag");
    });
    $(".frameMyUploadArea").on("drop", function (e) {
      $(this).removeClass("frameMyUploadAreaDrag");
      if (
        e.originalEvent.dataTransfer &&
        e.originalEvent.dataTransfer.files.length
      ) {
        e.preventDefault();
        e.stopPropagation();
        UploadImage(e.originalEvent.dataTransfer.files);
      }
    });

    $("#framePlusWelcome").click(function () {
      $("#frameMyAddImageByClick").val("");
      $("#frameMyAddImageByClick").click();
    });
  }
});
